import { stage } from "configs/api";
import {
  createBrowserRouter,
  createHashRouter,
  RouterProvider
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { HeroUIProvider } from "@heroui/react";

import "@rainbow-me/rainbowkit/styles.css";
import { Layout } from "components/Layout/Layout";
import { PrivyProvider } from "components/PrivyProvider";
import { DAppsPannel } from "screens/DApps/components/Pannel";
import { ROUTES } from "constants.routes";
import { Suggestions } from "screens/Suggestions";
import { Projects } from "screens/Projects";
import { AssociatedTokens } from "screens/AssociatedTokens";
import { LearnEarn } from "screens/LearnEarn";
import { NewsPage } from "./screens/News";
import { Campaigns } from "screens/Campaigns";
import { ThemeProvider as NextThemesProvider } from "next-themes";

const routes = [
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        path: ROUTES.DAPPS,
        element: <DAppsPannel />
      },
      {
        path: ROUTES.PROJECTS,
        element: <Projects />
      },
      {
        path: ROUTES.ASSOCIATED_TOKENS,
        element: <AssociatedTokens />
      },
      {
        path: ROUTES.SUGGESTIONS,
        element: <Suggestions />
      },
      {
        path: ROUTES.LEARN_EARN,
        element: <LearnEarn />
      },
      {
        path: ROUTES.NEWS,
        element: <NewsPage />
      },
      {
        path: ROUTES.CAMPAIGNS,
        element: <Campaigns />
      }
    ]
  }
];

const routers = {
  development: createHashRouter,
  staging: createHashRouter,
  production: createHashRouter
};

const router = routers[stage](routes, {
  basename: "/"
});

function App() {
  return (
    <PrivyProvider>
      <HeroUIProvider>
        <NextThemesProvider attribute="class" defaultTheme="dark">
          <ToastContainer className="toast-position" />
          <RouterProvider router={router} />
        </NextThemesProvider>
      </HeroUIProvider>
    </PrivyProvider>
  );
}

export default App;
